import data from "../../.sourceflow/sites.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const sites_helper = new CollectionHelper(data);
